import React from 'react';
import { useLingui } from '@lingui/react';
// eslint-disable-next-line no-restricted-imports
import { Link, Group } from '@landr/maestro';
import { Link as ReactRouterLink } from 'react-router-dom';
import { RoutePaths } from 'types/enums';
import { Filter } from 'types/generated/graphql';

export const SubFilterList = ({
    path,
    subFilters,
}: {
    path: RoutePaths;
    subFilters: Filter[];
}) => {
    const { i18n } = useLingui();

    return (
        <Group direction="vertical" gap="2xs">
            {subFilters?.map(
                (subFilter) =>
                    !!subFilter && (
                        <Group.Item>
                            <Link
                                as={ReactRouterLink}
                                to={`/${path}/${subFilter.code}`}
                                color="text.medium"
                                hasUnderline="hover"
                            >
                                {i18n._(subFilter.code)}
                            </Link>
                        </Group.Item>
                    ),
            )}
        </Group>
    );
};
